import { createStore } from "@xstate/store";

export type PanelId = "none" | "list" | "detail" | "session" | "agent";

export const panelStore = createStore({
  context: { activePanel: "none" as PanelId },
  on: {
    "panel.open": (_ctx, e: { panel: PanelId }) => ({ activePanel: e.panel }),
    "panel.close": () => ({ activePanel: "none" as PanelId }),
    "panel.toggle": (ctx, e: { panel: PanelId }) => ({
      activePanel: ctx.activePanel === e.panel ? ("none" as PanelId) : e.panel,
    }),
  },
});
